var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M92.969 36.313c-4.079.24-8.236 2.048-11.531 5.343L41.656 81.438c-6.59 6.59-7.17 16.673-1.312 22.531L192.375 256 40.344 408.031c-5.858 5.858-5.278 15.941 1.312 22.531l39.782 39.782c6.59 6.59 16.673 7.17 22.531 1.312L256 319.625l152.031 152.031c5.858 5.858 15.941 5.278 22.531-1.312l39.782-39.782c6.59-6.59 7.17-16.673 1.312-22.531L319.625 256l152.031-152.031c5.858-5.858 5.278-15.941-1.312-22.531l-39.782-39.782c-6.59-6.59-16.673-7.17-22.531-1.312L256 192.375 103.969 40.344c-2.929-2.93-6.921-4.271-11-4.032z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "error-icon.d14117e8f7addc0dee742b08014f65df.svg";